import { createContext, useContext } from 'react';
import type { IteroBrowseScope } from '../../../../hooks/useIteroBrowse';

export const IteroBrowserScopeContext = createContext<IteroBrowseScope | null>(null);

export function useIteroBrowserScope(): IteroBrowseScope {
    const scope = useContext(IteroBrowserScopeContext);
    if (!scope) throw new Error('useIteroBrowserScope must be used inside IteroBrowserModal');
    return scope;
}
